import { CollectClient } from "@tree-company/collect-js-client";

let collectorURL = import.meta.env.VITE_COLLECTOR_URL;
if (collectorURL === undefined && import.meta.env.DEV) {
  collectorURL = "http://localhost:3000";
}

export const apiClient = new CollectClient({
  url: collectorURL,
  projectKey: import.meta.env.VITE_COLLECTOR_KEY,
});
